import { render, staticRenderFns } from "./PaymentBadgeMulti.vue?vue&type=template&id=e129e69a&scoped=true"
import script from "./PaymentBadgeMulti.vue?vue&type=script&lang=js"
export * from "./PaymentBadgeMulti.vue?vue&type=script&lang=js"
import style0 from "./PaymentBadgeMulti.vue?vue&type=style&index=0&id=e129e69a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e129e69a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e129e69a')) {
      api.createRecord('e129e69a', component.options)
    } else {
      api.reload('e129e69a', component.options)
    }
    module.hot.accept("./PaymentBadgeMulti.vue?vue&type=template&id=e129e69a&scoped=true", function () {
      api.rerender('e129e69a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/payment/PaymentBadgeMulti.vue"
export default component.exports